import { render } from "./termsComponent.vue?vue&type=template&id=754648f2"
import script from "./termsComponent.vue?vue&type=script&lang=js"
export * from "./termsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__